import markdownItClass from '@toycode/markdown-it-class';
import format from 'date-fns/format';
import markdownIt from 'markdown-it';
import markdownItLinkAttributes from 'markdown-it-link-attributes';
import markdownItSanitizer from 'markdown-it-sanitizer';
import markdownItSup from 'markdown-it-sup';

// based on https://github.com/Wolox/react-chat-widget/blob/master/src/components/Widget/components/Conversation/components/Messages/components/Message/index.tsx

const PATCH_LISTS = /(^|\n)(\s*[\-*][^\n]*\n)([^ \n\-*])/g;

function Message({ text, role_sender, timestamp }) {
	const replaceAll = (str, find, replace) => str.replace(new RegExp(find, 'g'), replace);
	text = replaceAll(text, PATCH_LISTS, '$1$2\n$3')

    const sender = role_sender === "client" ? 'client' : 'response';
	const date = timestamp ? new Date(timestamp + '+00:00') : null;

	const sanitizedHTML = markdownIt({ breaks: true	})
		.use(markdownItClass, {
		img: ['rcw-message-img']
		})
		.use(markdownItSup)
		.use(markdownItSanitizer)
		.use(markdownItLinkAttributes, { attrs: { target: '_blank', rel: 'noopener' } })
		.render(text);

	return (
		<div className={`rcw-${sender}`}>
			<div className="rcw-message-text" dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
			{date ? <span className="rcw-timestamp">{format(date, 'HH:mm')}</span> : <></>}
		</div>
	);
}

export default Message;
